import { BuiltinInterface } from '../BuiltinInterface';
import { BuiltinValueObject } from '../BuiltinValueObject';
class BooleanInterface extends BuiltinInterface {
}
class BooleanValue extends BuiltinValueObject {
    constructor() {
        super(...arguments);
        this.type = 'BooleanConstructor';
    }
}
class BooleanConstructorInterface extends BuiltinInterface {
}
export const add = (builtins) => {
    builtins.addInterface('Boolean', new BooleanInterface());
    builtins.addValue('Boolean', new BooleanValue());
    builtins.addInterface('BooleanConstructor', new BooleanConstructorInterface());
};

//# sourceMappingURL=index.js.map
